import { TokenCard } from "@bkry/bowline-components/Token";
import { getProjectAttributes } from "@bkry/bowline-redux/projects";
import { listTokens } from "@bkry/bowline-redux/tokens";
import { getEnv } from "@bkry/bowline-utils";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { MdRefresh, MdSort } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";

const WalletTokens = (props, context) => {
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");
  const { account } = useWeb3React();
  const dispatch = useDispatch();
  const [sort, setSort] = useState({ created_at: "desc" });

  const projectData = useSelector((state) =>
    getProjectAttributes(state, REACT_APP_PROJECT_ID)
  );

  const signedInWithEthereum = useSelector(
    (state) => state.wallets.siweSuccess
  );

  const dispatchGetWalletTokens = async () => {
    // We want to update the list of tokens if there is an account
    if (account) {
      dispatch(
        listTokens({
          projectId: REACT_APP_PROJECT_ID,
          account: account,
          sorting: sort,
          filters: { wallet_address: account },
          pageNum: 1,
          itemNum: 20,
        })
      );
    } else {
      // TODO maybe move those checks to another place? also we should maybe check for renewing after X minutes or so
      console.log(
        "[DEBUG] Did not fire API requests since there is no account"
      );
    }
  };

  useEffect(() => {
    if (signedInWithEthereum) {
      dispatchGetWalletTokens();
    }
  }, [signedInWithEthereum, sort]);

  const tokenIds = useSelector((state) => state.tokens.idsList);
  const loadingList = useSelector((state) => state.tokens.loadingList);

  const isDropdownItemActive = (field, direction) => {
    return sort[field] === direction;
  };

  return (
    <>
      {loadingList && tokenIds.length <= 0 && (
        <div className="text-center">
          <Spinner color="primary" />
        </div>
      )}
      {tokenIds.length > 0 ? (
        <>
          <div className="d-flex justify-content-between mb-3">
            <span className="small text-center">
              {projectData?.title} {context.t("Tokens")}
            </span>
            <span className="d-flex gap-1">
              <Button
                onClick={() => dispatchGetWalletTokens()}
                color="primary"
                outline
                size="sm"
                title={context.t("Reload Tokens")}
              >
                <MdRefresh />
              </Button>
              <UncontrolledDropdown>
                <DropdownToggle caret color="primary" outline size="sm">
                  <MdSort />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={() => setSort({ created_at: "desc" })}
                    disabled={isDropdownItemActive("created_at", "desc")}
                  >
                    {context.t("Sort by Creation Date (Newest to Oldest)")}
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => setSort({ created_at: "asc" })}
                    disabled={isDropdownItemActive("created_at", "asc")}
                  >
                    {context.t("Sort by Creation Date (Oldest to Newest)")}
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => setSort({ identifier: "asc" })}
                    disabled={isDropdownItemActive("identifier", "asc")}
                  >
                    {context.t("Sort by Identifier (Lowest to Highest)")}
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => setSort({ identifier: "desc" })}
                    disabled={isDropdownItemActive("identifier", "desc")}
                  >
                    {context.t("Sort by Identifier (Highest to Lowest)")}
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => setSort({ contract_address: "asc" })}
                    disabled={isDropdownItemActive("contract_address", "asc")}
                  >
                    {context.t("Sort by Contract Address")}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </span>
          </div>
          <Row>
            {loadingList && (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            )}
            {tokenIds.map((tokenId) => (
              <Col key={`token-${tokenId}`} xs={6}>
                <TokenCard
                  tokenId={tokenId}
                  handleCardClickOverride={() => {}}
                />
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <div className="small text-center my-5">
          <p>
            {context.t("You do not have any Token in Wallet for this project")}
          </p>
          <Button
            onClick={() => dispatchGetWalletTokens()}
            color="primary"
            outline
            size="sm"
          >
            <MdRefresh className="me-2" />
            {context.t("Reload")}
          </Button>
        </div>
      )}
      <p className="small">
        {context.t(
          "Your Wallet might contain other Tokens from other dApps. Please visit the projects websites to see them or check your wallet on for example"
        )}{" "}
        <a
          href={`https://opensea.io/${account}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          OpenSea
        </a>
        {", "}
        <a
          href={`https://rarible.com/user/${account}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Rarible
        </a>{" "}
        {context.t("or")}{" "}
        <a
          href={`https://etherscan.io/address/${account}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          etherscan
        </a>
        .
      </p>
    </>
  );
};

/**  define proptype for the 'translation' function  */
WalletTokens.contextTypes = {
  t: PropTypes.func,
};

export default WalletTokens;
